import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { StepConfig } from '../../dynamicForm/types/fieldTypes';
import { getVehicleDataStep, vehicleDataStep } from '../steps/vehicleDataDefinition';
import { equipmentStep } from '../steps/equipmentDefinition';
import { photosStep } from '../steps/photosDefinition';
import { detailsStep } from '../steps/detailsDefinition';
import { contactStep } from '../steps/contactDefinition';

// Hook returning translated steps. Use this from React components.
export const useUserListingSteps = (): StepConfig[] => {
  const { t } = useTranslation();
  return useMemo(() => [
    getVehicleDataStep(t as any),
    {
      ...equipmentStep,
      title: t('listing_steps.equipment_title'),
      description: t('listing_steps.equipment_desc'),
    },
    {
      ...photosStep,
      title: t('listing_steps.photos_title'),
      description: t('listing_steps.photos_desc'),
    },
    {
      ...detailsStep,
      title: t('listing_steps.location_title'),
      description: t('listing_steps.location_desc'),
    },
    {
      ...contactStep,
      title: t('listing_steps.contact_title'),
      description: t('listing_steps.contact_desc'),
    },
  ], [t]);
};

// Legacy static export kept for non-React consumers
export const userListingSteps: StepConfig[] = [
  vehicleDataStep,
  equipmentStep,
  photosStep,
  detailsStep,
  contactStep,
];
